import localforage from "localforage";

const SPARXS_EDITOR_SESSION_INDEXEDDB_NAME = "sparx-editor-session-v1";
/** Logical 1.0.8 — adds persisted `sparxSession.byFileName` (unsaved edits); 1.0.7 was FileInfo.key + SearchIndexRow.listFingerprint. */
const SPARXS_EDITOR_SESSION_INDEXEDDB_VERSION = 8;

export const createSparxsEditorSessionIndexedDbStorage = () => {
  const db = localforage.createInstance({
    name: SPARXS_EDITOR_SESSION_INDEXEDDB_NAME,
    version: SPARXS_EDITOR_SESSION_INDEXEDDB_VERSION,
  });
  return {
    getItem: (key: string) => db.getItem<string>(key),
    setItem: (key: string, value: string) => db.setItem(key, value),
    removeItem: (key: string) => db.removeItem(key),
  };
};
